import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-amber-50 text-amber-800 py-12 border-t border-amber-100">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center">
          <p className="text-sm text-amber-700">{t('footer.copyright', { year: new Date().getFullYear() })}</p>
        </div>
        
        {/* Emergent Badge - placed in footer */}
        <div className="mt-8 pt-6 border-t border-amber-200 flex justify-center">
          <a
            href="https://app.emergent.sh/?utm_source=emergent-badge"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-3 py-1.5 bg-amber-100 hover:bg-amber-200 rounded-lg transition-colors text-xs text-amber-700 hover:text-amber-900"
          >
            <img
              src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4"
              alt="Emergent"
              className="w-4 h-4 mr-2 rounded"
            />
            Made with Emergent
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
